import type { BrandIconProps } from './brandIconTypes';

export default function AppleIcon({ className, ...props }: BrandIconProps) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M16.5542 5.79468C15.992 6.13489 15.5263 6.61052 15.2008 7.17706C14.8752 7.74361 14.7004 8.38253 14.6927 9.03404C14.6949 9.76732 14.9147 10.4838 15.3248 11.0949C15.7349 11.7059 16.3174 12.1846 17 12.4716C16.7309 13.33 16.3325 14.1434 15.8184 14.8845C15.0828 15.9313 14.3136 16.9779 13.1433 16.9779C11.973 16.9779 11.672 16.3058 10.3232 16.3058C9.00796 16.3058 8.53978 17 7.4697 17C6.39963 17 5.6529 16.0304 4.79457 14.8405C3.66079 13.1735 3.03768 11.2186 3 9.21028C3 5.90488 5.1736 4.15308 7.31364 4.15308C8.45063 4.15308 9.3981 4.8912 10.1115 4.8912C10.7914 4.8912 11.8504 4.10892 13.1433 4.10892C13.8081 4.09196 14.4669 4.23685 15.0617 4.53082C15.6565 4.82479 16.169 5.25882 16.5542 5.79468ZM12.5303 2.70969C13.1002 2.04695 13.4229 1.21096 13.4443 0.341378C13.4453 0.226741 13.4341 0.112322 13.4109 0C12.4318 0.0945337 11.5265 0.555779 10.8806 1.28913C10.3051 1.92546 9.97032 2.73912 9.93309 3.59183C9.93352 3.69554 9.94473 3.79892 9.96654 3.90035C10.0437 3.91478 10.1221 3.92217 10.2006 3.92244C10.6518 3.88695 11.091 3.76114 11.4915 3.55266C11.892 3.34418 12.2454 3.05738 12.5303 2.70969Z"
        fill="currentColor"
      />
    </svg>
  );
}
